/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import Page from '../../layout/Page/Page';
import Card, { CardBody, CardHeader } from '../../components/bootstrap/Card';
import Accordion, { AccordionItem } from '../../components/bootstrap/Accordion';
import Button from '../../components/bootstrap/Button';
import DatePicker from 'react-datepicker';
import { DefaultEditor } from 'react-simple-wysiwyg';
import 'react-time-picker/dist/TimePicker.css';
import 'react-datepicker/dist/react-datepicker.css';
import ImageUploading from 'react-images-uploading';
import FacebookLikeSVG from '../../assets/social-media-icons/facebook-post-like.svg';
import FacebookCommentSVG from '../../assets/social-media-icons/facebook-comment-icon.svg';
import FacebookShareSVG from '../../assets/social-media-icons/facebook-post-share.svg';
import LinkedinLikeSVG from '../../assets/social-media-icons/linkedin-like-icon.svg';
import LinkedinCommentSVG from '../../assets/social-media-icons/linkedin-comment-icon.svg';
import LinkedinShareSVG from '../../assets/social-media-icons/linkedin-share-icon.svg';
import LinkedinSendSVG from '../../assets/social-media-icons/linkedin-send-icon.svg';
import TwitterLikeIcon from '../../assets/social-media-icons/twitter-like-icon.svg';
import TwitterCommentIcon from '../../assets/social-media-icons/twitter-commment-icon.svg';
import TwitterRetweetIcon from '../../assets/social-media-icons/twitter-retwitt-icon.svg';
import TwitterDownloadIcon from '../../assets/social-media-icons/twitter-down-arrow.svg';
import { MoreVert } from '../../components/icon/material-icons';

const FacebookPreview = () => {
    return (
        <>
            <div className='facebook-preview'>
                <div className='account-left' style={{ padding: '12px' }}>
                    <div className='user-profile'>
                        <h5>DS</h5>
                    </div>
                    <div className='account-details'>
                        <p className='account-name'>Test</p>
                        <p className='account-type'>Jul 21</p>
                    </div>
                </div>
                <div
                    className='account-body'
                    style={{ padding: '12px', paddingTop: '0px' }}>
                    <p className='desc-text' style={{ marginBottom: '0px' }}>
                        Hello
                    </p>
                </div>
                <div className='account-img'>
                    <img
                        src={require('../../assets/post-img.png')}
                        alt='Post'
                    />
                </div>
                <div className='options-media d-flex'>
                    <div className='d-flex'>
                        <img
                            src={FacebookLikeSVG}
                            width='20'
                            alt='Facebook Like'
                        />
                        <p
                            style={{
                                marginBottom: '0px',
                                marginLeft: '5px',
                            }}>
                            Like
                        </p>
                    </div>
                    <div className='d-flex'>
                        <img
                            src={FacebookCommentSVG}
                            width='20'
                            alt='Facebook Comment'
                        />
                        <p
                            style={{
                                marginBottom: '0px',
                                marginLeft: '5px',
                            }}>
                            Comment
                        </p>
                    </div>
                    <div className='d-flex'>
                        <img
                            src={FacebookShareSVG}
                            width='20'
                            alt='Facebook Share'
                        />
                        <p
                            style={{
                                marginBottom: '0px',
                                marginLeft: '5px',
                            }}>
                            Share
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

const LinkedinPreview = () => {
    return (
        <>
            <div className='facebook-preview'>
                <div className='account-left' style={{ padding: '12px' }}>
                    <div className='user-profile'>
                        <h5>DS</h5>
                    </div>
                    <div className='account-details'>
                        <p className='account-name'>Test</p>
                        <p className='account-type'>Jul 21</p>
                    </div>
                </div>
                <div
                    className='account-body'
                    style={{ padding: '12px', paddingTop: '0px' }}>
                    <p className='desc-text' style={{ marginBottom: '0px' }}>
                        Hello
                    </p>
                </div>
                <div className='account-img'>
                    <img
                        src={require('../../assets/post-img.png')}
                        alt='Post'
                    />
                </div>
                <div className='options-media d-flex'>
                    <div className='d-flex'>
                        <img
                            src={LinkedinLikeSVG}
                            width='20'
                            alt='Linkedin Like'
                        />
                        <p
                            style={{
                                marginBottom: '0px',
                                marginLeft: '5px',
                            }}>
                            Like
                        </p>
                    </div>
                    <div className='d-flex'>
                        <img
                            src={LinkedinCommentSVG}
                            width='20'
                            alt='Linkedin Comment'
                        />
                        <p
                            style={{
                                marginBottom: '0px',
                                marginLeft: '5px',
                            }}>
                            Comment
                        </p>
                    </div>
                    <div className='d-flex'>
                        <img
                            src={LinkedinShareSVG}
                            width='20'
                            alt='Linkedin Share'
                        />
                        <p
                            style={{
                                marginBottom: '0px',
                                marginLeft: '5px',
                            }}>
                            Share
                        </p>
                    </div>
                    <div className='d-flex'>
                        <img
                            src={LinkedinSendSVG}
                            width='20'
                            alt='Linkedin Send'
                        />
                        <p
                            style={{
                                marginBottom: '0px',
                                marginLeft: '5px',
                            }}>
                            Send
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

const InstagramPreview = () => {
    return (
        <>
            <div className='facebook-preview'>
                <div
                    className='account-left'
                    style={{
                        padding: '12px',
                        justifyContent: 'space-between',
                    }}>
                    <div className='d-flex' style={{ alignItems: 'center' }}>
                        <div className='user-profile'>
                            <h5>DS</h5>
                        </div>
                        <div className='account-details'>
                            <p className='account-name'>Test</p>
                        </div>
                    </div>
                    <MoreVert />
                </div>
                <div className='account-img' style={{ borderBottom: '0px' }}>
                    <img
                        src={require('../../assets/post-img.png')}
                        alt='Post'
                    />
                </div>
                <div
                    className='options-media d-flex'
                    style={{ justifyContent: 'space-between' }}>
                    <div className='d-flex'>
                        <svg
                            aria-label='Unlike'
                            className='_ab6-'
                            color='#262626'
                            height='24'
                            role='img'
                            viewBox='0 0 24 24'
                            width='24'>
                            <path d='M16.792 3.904A4.989 4.989 0 0121.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 014.708-5.218 4.21 4.21 0 013.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 013.679-1.938m0-2a6.04 6.04 0 00-4.797 2.127 6.052 6.052 0 00-4.787-2.127A6.985 6.985 0 00.5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 003.518 3.018 2 2 0 002.174 0 45.263 45.263 0 003.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 00-6.708-7.218z' />
                        </svg>
                        <svg
                            aria-label='Comment'
                            className='_ab6-'
                            color='#262626'
                            fill='#262626'
                            height='24'
                            role='img'
                            style={{ marginLeft: '5px' }}
                            viewBox='0 0 24 24'
                            width='24'>
                            <path
                                d='M20.656 17.008a9.993 9.993 0 10-3.59 3.615L22 22z'
                                fill='none'
                                stroke='currentColor'
                                strokeLinejoin='round'
                                strokeWidth='2'
                            />
                        </svg>
                        <svg
                            aria-label='Share Post'
                            className='_ab6-'
                            color='#262626'
                            fill='#262626'
                            height='24'
                            role='img'
                            style={{ marginLeft: '5px' }}
                            viewBox='0 0 24 24'
                            width='24'>
                            <line
                                fill='none'
                                stroke='currentColor'
                                strokeLinejoin='round'
                                strokeWidth='2'
                                x1='22'
                                x2='9.218'
                                y1='3'
                                y2='10.083'
                            />
                            <polygon
                                fill='none'
                                points='11.698 20.334 22 3.001 2 3.001 9.218 10.084 11.698 20.334'
                                stroke='currentColor'
                                strokeLinejoin='round'
                                strokeWidth='2'
                            />
                        </svg>
                    </div>
                    <svg
                        aria-label='Save'
                        className='_ab6-'
                        color='#262626'
                        fill='#262626'
                        height='24'
                        role='img'
                        viewBox='0 0 24 24'
                        width='24'>
                        <polygon
                            fill='none'
                            points='20 21 12 13.44 4 21 4 3 20 3 20 21'
                            stroke='currentColor'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                        />
                    </svg>
                </div>
            </div>
        </>
    );
};

const TwitterPreview = () => {
    return (
        <>
            <div className='twitter-preview'>
                <div className='d-flex' style={{ width: '100%' }}>
                    <div className='preview-left'>
                        <div className='user-profile'>
                            <h5>DS</h5>
                        </div>
                    </div>
                    <div className='preview-right'>
                        <div className='d-flex' style={{ width: '100%' }}>
                            <p className='account-name'>RoundTechSquare</p>
                            <p
                                className='account-name'
                                style={{
                                    fontWeight: '400',
                                    marginLeft: '5px',
                                }}>
                                @RoundTechSquare
                            </p>
                        </div>
                        <div
                            className='account-body'
                            style={{ marginBottom: '10px', marginTop: '10px' }}>
                            <p
                                className='desc-text'
                                style={{ marginBottom: '0px' }}>
                                Hello
                            </p>
                        </div>
                        <div
                            className='account-img'
                            style={{ borderBottom: '0px solid transparent' }}>
                            <img
                                src={require('../../assets/post-img.png')}
                                alt='Post'
                            />
                        </div>
                        <div
                            className='options-media'
                            style={{ padding: '0px', paddingTop: '12px' }}>
                            <div
                                className='d-flex'
                                style={{ justifyContent: 'space-between' }}>
                                <img
                                    src={TwitterLikeIcon}
                                    width='20'
                                    alt='Twitter Like'
                                />
                                <img
                                    src={TwitterCommentIcon}
                                    width='20'
                                    alt='Twitter Comment'
                                />
                                <img
                                    src={TwitterRetweetIcon}
                                    width='20'
                                    alt='Twitter Retweet'
                                />
                                <img
                                    src={TwitterDownloadIcon}
                                    width='20'
                                    alt='Twitter Down'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const PublishPost = () => {
    const [publishDate, setPublishDate] = useState(new Date());
    const handlePublishDate = (date: Date) => {
        setPublishDate(date);
    };

    const [hideScheduleBody, setHideScheduleBody] = useState(false);
    const handleSchedule = (e: any) => {
        e.target.value === 'Immediately'
            ? setHideScheduleBody(!hideScheduleBody)
            : setHideScheduleBody(!hideScheduleBody);
    };

    const [descriptionText, setDescriptionText] = useState(
        '<html>Post Description</html>',
    );
    const onDescriptionTextChange = (e: any) => {
        setDescriptionText(e.target.value);
    };

    const [selectedImages, setSelectedImages] = useState([]);
    const onSelectedImageList = (imageList: any) => {
        setSelectedImages(imageList);
    };

    const [postPreviewActive, setPostPreviewActive] = useState(true);

    return (
        <PageWrapper title='Publish Post'>
            <Page container='fluid'>
                <div className='row'>
                    <div className='col-xl-5 col-sm-12'>
                        <div
                            className='row'
                            style={{ justifyContent: 'center' }}>
                            <div className='col-xl-10 col-sm-12'>
                                <form>
                                    {/* ACCOUNT SELECTION */}
                                    <div className='row'>
                                        <Accordion
                                            id='account-selection'
                                            className='account-selection-card'>
                                            <AccordionItem
                                                id='account-selection'
                                                title='Select the account where you want to post'>
                                                {/* FACEBOOK ACCOUNTS */}
                                                <div className='facebook mb-4'>
                                                    <h5 className='platform-heading'>
                                                        Facebook
                                                    </h5>
                                                    <div className='account-selection mt-2'>
                                                        <div className='account-left'>
                                                            <div className='user-profile'>
                                                                <h5>DS</h5>
                                                            </div>
                                                            <div className='account-details'>
                                                                <p className='account-name'>
                                                                    <img
                                                                        src={require('../../assets/facebook.png')}
                                                                        width='15'
                                                                        style={{
                                                                            marginRight:
                                                                                '5px',
                                                                        }}
                                                                        alt='Facebook'
                                                                    />
                                                                    Test
                                                                </p>
                                                                <p className='account-type'>
                                                                    Facebook
                                                                    Page
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className='account-right'>
                                                            <input
                                                                type='checkbox'
                                                                id='facebook-account-select'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* LINKEDIN ACCOUNTS */}
                                                <div className='linkedin mb-4'>
                                                    <h5 className='platform-heading'>
                                                        Linkedin
                                                    </h5>
                                                    <div className='account-selection mt-2'>
                                                        <div className='account-left'>
                                                            <div className='user-profile'>
                                                                <h5>DS</h5>
                                                            </div>
                                                            <div className='account-details'>
                                                                <p className='account-name'>
                                                                    <img
                                                                        src={require('../../assets/linkedin.png')}
                                                                        width='15'
                                                                        style={{
                                                                            marginRight:
                                                                                '5px',
                                                                        }}
                                                                        alt='Linkedin'
                                                                    />
                                                                    Darsh Shah
                                                                </p>
                                                                <p className='account-type'>
                                                                    Personal
                                                                    Profile
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className='account-right'>
                                                            <input
                                                                type='checkbox'
                                                                id='facebook-account-select'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* TWITTER ACCOUNTS */}
                                                <div className='twitter mb-4'>
                                                    <h5 className='platform-heading'>
                                                        Twitter
                                                    </h5>
                                                    <div className='account-selection mt-2'>
                                                        <div className='account-left'>
                                                            <div className='user-profile'>
                                                                <h5>DS</h5>
                                                            </div>
                                                            <div className='account-details'>
                                                                <p className='account-name'>
                                                                    <img
                                                                        src={require('../../assets/twitter.png')}
                                                                        width='15'
                                                                        style={{
                                                                            marginRight:
                                                                                '5px',
                                                                        }}
                                                                        alt='Twitter'
                                                                    />
                                                                    Darsh Shah
                                                                </p>
                                                                <p className='account-type'>
                                                                    Personal
                                                                    Profile
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className='account-right'>
                                                            <input
                                                                type='checkbox'
                                                                id='facebook-account-select'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* INSTAGARM ACCOUNTS */}
                                                <div className='instagram mb-4'>
                                                    <h5 className='platform-heading'>
                                                        Instagram
                                                    </h5>
                                                    <div className='account-selection mt-2'>
                                                        <div className='account-left'>
                                                            <div className='user-profile'>
                                                                <h5>DS</h5>
                                                            </div>
                                                            <div className='account-details'>
                                                                <p className='account-name'>
                                                                    <img
                                                                        src={require('../../assets/instagram.png')}
                                                                        width='15'
                                                                        style={{
                                                                            marginRight:
                                                                                '5px',
                                                                        }}
                                                                        alt='Instagram'
                                                                    />
                                                                    Darsh Shah
                                                                </p>
                                                                <p className='account-type'>
                                                                    Personal
                                                                    Profile
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className='account-right'>
                                                            <input
                                                                type='checkbox'
                                                                id='facebook-account-select'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* CONNECT MORE PROFILES BUTTON */}
                                                <Button
                                                    style={{ width: '100%' }}
                                                    color='primary'
                                                    isOutline>
                                                    Connect More Profiles
                                                </Button>
                                            </AccordionItem>
                                        </Accordion>
                                    </div>
                                    {/* EDITING SECTION */}
                                    <div className='row mt-4'>
                                        <Card className='editor-card'>
                                            <CardBody className='editor-card-body'>
                                                <DefaultEditor
                                                    className='editor-control-text'
                                                    value={descriptionText}
                                                    placeholder='Post Description'
                                                    onChange={
                                                        onDescriptionTextChange
                                                    }
                                                />
                                            </CardBody>
                                        </Card>
                                    </div>
                                    {/* IMAGE SELECTION */}
                                    <div className='row mt-1'>
                                        <Accordion
                                            id='image-selection'
                                            className='image-selection-card'>
                                            <AccordionItem
                                                id='image-selection'
                                                title='Select the images which you want to post'>
                                                <div className='upload-list'>
                                                    <ImageUploading
                                                        multiple
                                                        value={selectedImages}
                                                        onChange={
                                                            onSelectedImageList
                                                        }
                                                        dataURLKey='data_url'
                                                        maxNumber={10}>
                                                        {({
                                                            imageList,
                                                            onImageUpload,
                                                            onImageUpdate,
                                                            onImageRemove,
                                                        }) => (
                                                            <div className='accordion-body-images'>
                                                                <div
                                                                    className='upload-box'
                                                                    onClick={
                                                                        onImageUpload
                                                                    }>
                                                                    <img
                                                                        src={require('../../assets/upload-icon.png')}
                                                                        width='30'
                                                                        alt='Upload Icon'
                                                                    />
                                                                </div>
                                                                {imageList.map(
                                                                    (
                                                                        image,
                                                                        index,
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                            className='uploaded-img'>
                                                                            <img
                                                                                src={
                                                                                    image.data_url
                                                                                }
                                                                                alt=''
                                                                                style={{
                                                                                    width: '100%',
                                                                                }}
                                                                            />
                                                                            <div className='options'>
                                                                                <Button
                                                                                    color='dark'
                                                                                    isOutline
                                                                                    icon='Trash'
                                                                                    onClick={() =>
                                                                                        onImageRemove(
                                                                                            index,
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <Button
                                                                                    style={{
                                                                                        marginLeft:
                                                                                            '5px',
                                                                                    }}
                                                                                    color='primary'
                                                                                    isOutline
                                                                                    icon='Create'
                                                                                    onClick={() =>
                                                                                        onImageUpdate(
                                                                                            index,
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                )}
                                                            </div>
                                                        )}
                                                    </ImageUploading>
                                                </div>
                                            </AccordionItem>
                                        </Accordion>
                                    </div>
                                    {/* TIME AND DATE FOR PUBLISHING POST */}
                                    <div className='row mt-4'>
                                        <Card stretch className='schedule-card'>
                                            <CardHeader
                                                className='schedule-card-header'
                                                style={{
                                                    borderBottom:
                                                        '0px solid transparent',
                                                }}>
                                                <p
                                                    style={{
                                                        fontWeight: '600',
                                                        fontSize: '16px',
                                                    }}>
                                                    Select the time to post
                                                </p>
                                                <select
                                                    id='time-option'
                                                    onChange={handleSchedule}
                                                    className='time-option-control'>
                                                    <option value='Specific Days & Times'>
                                                        Specific Day &amp; Time
                                                    </option>
                                                    <option value='Immediately'>
                                                        Immediately
                                                    </option>
                                                </select>
                                            </CardHeader>
                                            <CardBody
                                                className={
                                                    hideScheduleBody
                                                        ? 'd-none schedule-card-body'
                                                        : 'd-block schedule-card-body'
                                                }>
                                                <div className='d-flex'>
                                                    <div className='date-selection'>
                                                        <label htmlFor='date'>
                                                            Date
                                                        </label>
                                                        <DatePicker
                                                            name='date'
                                                            className='datepicker-control'
                                                            selected={
                                                                publishDate
                                                            }
                                                            onChange={
                                                                handlePublishDate
                                                            }
                                                        />
                                                    </div>
                                                    <div className='time-selection'>
                                                        <label htmlFor='time'>
                                                            Time
                                                        </label>
                                                        <input
                                                            type='time'
                                                            name='time'
                                                            value='10:00'
                                                            className='time-control'
                                                        />
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                    {/* PUBLISH BUTTON */}
                                    {hideScheduleBody ? (
                                        <div
                                            className='row mt-2'
                                            style={{ justifyContent: 'end' }}>
                                            <Button
                                                className='gradient-btn-custom'
                                                style={{ width: '30%' }}>
                                                Publish Post
                                            </Button>
                                        </div>
                                    ) : (
                                        <div
                                            className='row mt-2'
                                            style={{ justifyContent: 'end' }}>
                                            <Button
                                                className='gradient-btn-custom'
                                                style={{ width: '30%' }}>
                                                Schedule Post
                                            </Button>
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className='col-xl-7 col-sm-12'>
                        <div className='preview-section'>
                            <h5 className='preview-heading'>Post Preview</h5>
                            <p>
                                Preview approximates how your content will
                                display when published. Tests and updates by
                                social networks may affect the final appearance.
                            </p>
                            <div className='preview-options mt-4'>
                                <div className='row'>
                                    {!postPreviewActive ? (
                                        <img
                                            src={require('../../assets/preview-demo.PNG')}
                                            style={{ width: '500px' }}
                                            alt='Post Preview'
                                        />
                                    ) : (
                                        <div className='row'>
                                            <div className='col-xl-6 col-sm-12'>
                                                <Card
                                                    stretch
                                                    className='preview-card'>
                                                    <CardHeader>
                                                        <div
                                                            className='d-flex'
                                                            style={{
                                                                alignItems:
                                                                    'center',
                                                            }}>
                                                            <img
                                                                src={require('../../assets/facebook.png')}
                                                                width='20'
                                                                alt='Facebook Icon'
                                                            />
                                                            <p className='platform-name'>
                                                                Facebook
                                                            </p>
                                                        </div>
                                                    </CardHeader>
                                                    <CardBody
                                                        style={{
                                                            paddingTop: '0px',
                                                        }}>
                                                        <FacebookPreview />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <Card
                                                    stretch
                                                    className='preview-card'>
                                                    <CardHeader>
                                                        <div
                                                            className='d-flex'
                                                            style={{
                                                                alignItems:
                                                                    'center',
                                                            }}>
                                                            <img
                                                                src={require('../../assets/linkedin.png')}
                                                                width='20'
                                                                alt='LinkedinIcon'
                                                            />
                                                            <p className='platform-name'>
                                                                Linkedin
                                                            </p>
                                                        </div>
                                                    </CardHeader>
                                                    <CardBody
                                                        style={{
                                                            paddingTop: '0px',
                                                        }}>
                                                        <LinkedinPreview />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <Card
                                                    stretch
                                                    className='preview-card'>
                                                    <CardHeader>
                                                        <div
                                                            className='d-flex'
                                                            style={{
                                                                alignItems:
                                                                    'center',
                                                            }}>
                                                            <img
                                                                src={require('../../assets/instagram.png')}
                                                                width='20'
                                                                alt='InstagramIcon'
                                                            />
                                                            <p className='platform-name'>
                                                                Instagram
                                                            </p>
                                                        </div>
                                                    </CardHeader>
                                                    <CardBody
                                                        style={{
                                                            paddingTop: '0px',
                                                        }}>
                                                        <InstagramPreview />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <Card
                                                    stretch
                                                    className='preview-card'>
                                                    <CardHeader>
                                                        <div
                                                            className='d-flex'
                                                            style={{
                                                                alignItems:
                                                                    'center',
                                                            }}>
                                                            <img
                                                                src={require('../../assets/twitter.png')}
                                                                width='20'
                                                                alt='TwitterIcon'
                                                            />
                                                            <p className='platform-name'>
                                                                Twitter
                                                            </p>
                                                        </div>
                                                    </CardHeader>
                                                    <CardBody
                                                        style={{
                                                            paddingTop: '0px',
                                                        }}>
                                                        <TwitterPreview />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default PublishPost;
